import { render, staticRenderFns } from "./Kuesioner.vue?vue&type=template&id=5daf5aed&scoped=true&"
import script from "./Kuesioner.vue?vue&type=script&lang=js&"
export * from "./Kuesioner.vue?vue&type=script&lang=js&"
import style0 from "./Kuesioner.vue?vue&type=style&index=0&id=5daf5aed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf5aed",
  null
  
)

export default component.exports